import React from 'react'
import { useTranslation } from 'react-i18next'
import * as S from './SectionEnriquecaAulas.styles'
import ImageNext from '@/components/ImageNext'

const SectionEnriqueçaAulas = () => {
  const { t } = useTranslation()

  return (
    <S.Section>
      <S.Title>{t('landingV2.sectionEnriquecaAulas.title')}</S.Title>
      <S.Row>
        <S.ImageCol>
          <ImageNext
            src={`${process.env.CDN_URL}/public/landingpagev2/defaults/start-viewer-3d-home.png`}
            alt="Visualização 3D BioAtlas"
            width={547}
            height={502}
            style={{
              maxWidth: '100%',
              height: 'auto',
              width: 'auto',
              borderRadius: 16
            }}
            priority
          />
        </S.ImageCol>
        <S.TextCol>
          <S.Block>
            <S.BlockTitle>
              {t('landingV2.sectionEnriquecaAulas.blocks.visualizacao.title')}
            </S.BlockTitle>
            <S.BlockText>
              {t('landingV2.sectionEnriquecaAulas.blocks.visualizacao.text')}
            </S.BlockText>
          </S.Block>
          <S.Block>
            <S.BlockTitle>
              {t('landingV2.sectionEnriquecaAulas.blocks.integracao.title')}
            </S.BlockTitle>
            <S.BlockText>
              {t('landingV2.sectionEnriquecaAulas.blocks.integracao.text')}
            </S.BlockText>
          </S.Block>
          <S.Block>
            <S.BlockTitle>
              {t('landingV2.sectionEnriquecaAulas.blocks.customizacao.title')}
            </S.BlockTitle>
            <S.BlockText>
              {t('landingV2.sectionEnriquecaAulas.blocks.customizacao.text')}
            </S.BlockText>
          </S.Block>
        </S.TextCol>
      </S.Row>
    </S.Section>
  )
}

export default SectionEnriqueçaAulas
